import React from 'react';

// Use a descriptive name for the background image path
// Make sure to save a high-quality version of the field/farmer image
const BANNER_IMAGE_URL = "https://kisaanmitra.com/wp-content/uploads/2020/01/kisaan-Mitra-Vermicompost-Unit-Feature-Image.png"; 

const Banner: React.FC = () => {
    return (
        // The main banner container
        <div 
            className="relative w-full h-[65vh] md:h-[70vh] bg-cover bg-center"
            style={{ 
                backgroundImage: `url(${BANNER_IMAGE_URL})`,
                // This property (background-attachment: fixed) makes the image stay 
                // fixed while the content scrolls over it, creating the effect you asked for.
                backgroundAttachment: 'fixed' 
            }}
        >
            {/* Dark/Green Overlay for better text readability */}
            <div className="absolute inset-0 bg-[#4f6a39]/20 flex items-center justify-center p-4 sm:p-8">
                
                {/* Text Content */}
                <div className="text-center text-gray-900 max-w-4xl px-4 ">
                    <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold font-serif leading-tight tracking-wide">
                        Transform waste into fertile soil, 
                        nurture healthier <span className='text-orange-900'>plants, 
                        and grow a greener future.</span>
                    </h1>
                </div>
            </div>
        </div>
    );
};

export default Banner;